import { URLS } from "@/config/domains";

import { MarketingContainer } from "./ui/MarketingContainer";

export function MarketingFooter() {
  return (
    <footer className="border-t border-white/5 bg-slate-950">
      <MarketingContainer className="py-10">
        <div className="flex flex-col gap-8 md:flex-row md:items-center md:justify-between">
          <div>
            <p className="text-lg font-bold text-white">
              Ministry
              <span className="text-indigo-400">
                IQ
              </span>
            </p>

            <p className="mt-2 text-sm text-slate-500">
              See More. Care Better. Lead Smarter.
            </p>
          </div>

          <div className="flex flex-wrap gap-x-6 gap-y-3 text-sm text-slate-400">
            <a
              href="#features"
              className="transition hover:text-white"
            >
              Features
            </a>

            <a
              href="#pricing"
              className="transition hover:text-white"
            >
              Pricing
            </a>

            <a
              href="#faq"
              className="transition hover:text-white"
            >
              FAQ
            </a>

            <a
              href="/request-access"
              className="transition hover:text-white"
            >
              Request Pilot Access
            </a>

            <a
              href={`${URLS.church}/app/login`}
              className="transition hover:text-white"
            >
              Church Login
            </a>
          </div>
        </div>

        <div className="mt-8 border-t border-white/5 pt-6 text-sm text-slate-600">
          � {new Date().getFullYear()} MinistryIQ.
          All rights reserved.
        </div>
      </MarketingContainer>
    </footer>
  );
}
